export const actualFields = {
  anchorCount: 'Anchor tenant count',
  waitHours: 'Wait time (hours)',
  equipmentHours: 'Equipment inspection (hours)',
  propertyHours: 'Property inspection (hours)',
  travelHours: 'Remote round-trip travel (hours)',
  visit: 'Actual visit',
  expenses: 'Receipts and expenses',
  returnTripCause: 'Return-trip cause',
} as const;
export type ActualField = keyof typeof actualFields;
export interface ActualsConfig {
  fields: ActualField[];
  quantitySources?: Record<string, string>;
  purchaseCapField?: string | null;
  purchaseCurrencyField?: string | null;
}
export interface ActualExpense {
  id: string;
  kind: 'Purchase' | 'OvernightShipping';
  amount: number;
  currency: string;
  receiptImageId?: number | null;
}
export interface ActualFacts {
  anchorCount?: number | null;
  waitHours?: number | null;
  equipmentHours?: number | null;
  propertyHours?: number | null;
  travelHours?: number | null;
  visitedAt?: string | null;
  timezoneId?: string | null;
  returnTripCause?: string | null;
  expenses: ActualExpense[];
}
export interface ActualsRevision {
  revision: number;
  kind: string;
  createdBy: number;
  createdAt: string;
  operationId: string;
  data: {
    facts: ActualFacts;
    reason: string;
    metadataId: number;
    assignmentId: number;
    purchaseCap?: number | null;
    purchaseCurrency?: string | null;
    reviewedExpenses: {
      id: string;
      actualAmount: number;
      reimbursableAmount: number;
      excessAmount: number;
      currency: string;
    }[];
  };
}
export interface ActualsResponse {
  pendingSubmission?: ActualsRequest;
  config: ActualsConfig;
  canSubmit: boolean;
  canReview: boolean;
  revision: number;
  isApproved: boolean;
  history: ActualsRevision[];
  timingEvidence: { id: number; eventType: string; eventAt: string }[];
}
export interface ActualsRequest {
  operationId: string;
  expectedRevision: number;
  facts: ActualFacts;
  reason: string;
}
export interface WorkActualsServices {
  subscribeToSync?: (listener: () => void) => () => void;
  loadReceipts: (
    controller: AbortController,
    workId: number
  ) => Promise<{ id: number; label: string }[]>;
  load: (
    controller: AbortController,
    workId: number
  ) => Promise<ActualsResponse>;
  save: (
    controller: AbortController,
    workId: number,
    request: ActualsRequest,
    approve: boolean
  ) => Promise<ActualsResponse | { queued: true }>;
}
